import { TimePickerCSSStyleImpl } from "./timepickercss";
import { TimePickerView } from "./timepickerview";
import * as moment from 'moment';
import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { UIComponentView } from '../uicomponentview';
import './timepicker.css';
export interface TimePickerProps extends UIComponentProps
{
    id: string;
    label:string;
    value: any;
    placeholder: string;
    inputType: string;
    isRequired: boolean;
    emptyErrorMsg: string;
    isDisabled:boolean;
    format:string;
    autocomplete?:string;
    onChange(data:string):void;
    onKeyPress(e:React.KeyboardEvent):void;
}

export interface TimePickerState extends UIComponentState{
    value:any;  
    errorMessage:string|undefined;
}

export interface TimePickerHandler extends UIComponentHandler{
    onChange(data:any):void;

}

export class TimePickerComponent extends UIComponentImpl<TimePickerProps, 
TimePickerState, UIDataModel> implements TimePickerHandler
{
    


    constructor(textprops: TimePickerProps){
        super(textprops);

        this.state = {value: this.props.value === "" ? "" :
        this.convertToStandardTime(this.props.value), errorMessage: undefined};


    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new TimePickerView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new TimePickerCSSStyleImpl(applicationContext);
    }

    // UNSAFE_componentWillReceiveProps(newProps:TimePickerProps){
    //     console.log("component will receive in time picker", newProps.value);
    //     this.setState({value: newProps.value});
    // }
    setErrorMessage(errorMesssage: string)
    {
        this.setState({errorMessage: errorMesssage});
    }

    
    onChange(data: any): void 
    {
        if (data !== '') {
            this.setState({value: data});
        }
        else {
                this.setState({value: data});
        }
    }

    
    clearData()
    {
        this.setState({value: "", errorMessage: undefined});
    }

    validate(): boolean
    {
        if(this.props.isRequired && this.state.value.length === 0)
        {
            this.setState({errorMessage: this.props.emptyErrorMsg});

            return false;
        }
        else
        {
            this.setState({errorMessage: undefined});

            return true;
        }
    }


   //

   

    getData()
    {
        let formattedTime = moment(this.state.value).format(this.props.format);
        
        // let textAreaModel = new FormItemModel(DataValueFactory.
        //     createDataValue(DataValueTypes.USER_DEFINED, 0, formattedTime)); 
        return formattedTime;
    }

    // clearData()
    // {
    //     this.setState({value: "", errorMessage: undefined});
    // }

    // validate(): boolean
    // {
    //     let validationModel:any = 
    //     this.props.propertyModel.isValid(this.state.data === null ? "" : this.state.data);

    //     if(!validationModel.isValid())
    //     {
    //         this.setState({errorMessage: validationModel.getMessage()});
    //     }else{
    //         this.setState({errorMessage: undefined});
    //     }

    //     return validationModel.isValid();
    // }

    toggleComponent(canShow: any)
    {
            this.forceUpdate();
    }

    updateDataChange(isChecked: boolean)
    {
    }

    private convertToStandardTime(utcDate:string) 
    {
        var formattedData = moment(utcDate, this.props.format);

        return formattedData.toDate();
        
    }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/timepicker/timepicker.tsx